export interface StrategyFilterState {
    query: string;
    productType: number;
    sortBy: string;
    filter: string;
}

export interface TabsState {
    Deployed: StrategyFilterState;
    Shared: StrategyFilterState;    
    Created: StrategyFilterState;
    Subscribed: StrategyFilterState;
    Saved: StrategyFilterState;
}